import React, { createRef } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Message } from "@jdcfe/legao";
import VopHeader from "components/vop_header";
import HomeHeader from "components/HomeHeader"
import VopFooter from "components/vop_footer";
import { updatePassword } from "utils/api";
import { loginUrl } from "utils/api/ajax";
import "./style.scss";
let md5 = require("md5");

class EditPsd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPsd: '',
      newPsd: '',
      againPsd: ''
    };
    this.headerRef = createRef();
  }
  componentDidMount() {
    document.title = "京东VOP开放平台-修改密码";

    if (this.headerRef.current) {
      this.headerRef.current.style.width = window.innerWidth <= 1200 ? '100%' : '1200px';
    }
    console.log('0', this.state)
  }
  inputOld = (e) => {
    console.log('e.target.value', e.target.value)
    this.setState({
      oldPsd: e.target.value
    });
    console.log('inputValue', this.state)
  }
  inputNew = (e) => {
    this.setState({
      newPsd: e.target.value
    });
  }
  inputAgain = (e) => {
    this.setState({
      againPsd: e.target.value
    });
  }

  async handleCreate(){
    // console.log('inputValue', this.state)

    // 校验规则
    // 数字/字母/符号两种以上组合，8-20位
    // var reg = /(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/;
    var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/;
    console.log(reg.test(this.state.oldPsd));
    if(this.state.oldPsd == null || this.state.oldPsd.length ==0) {
      Message.showMsg({
        showIcon: true,
        type: "success",
        description: "老密码为空，请填写",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return
    } else if(this.state.newPsd == null || this.state.newPsd.length ==0) {
      Message.showMsg({
        showIcon: true,
        type: "success",
        description: "新密码为空，请填写",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return
    } else if(this.state.againPsd == null || this.state.againPsd.length ==0) {
      Message.showMsg({
        showIcon: true,
        type: "success",
        description: "确认新密码为空，请填写",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return
    } else if(!reg.test(this.state.newPsd)) {
      Message.showMsg({
        showIcon: true,
        type: "success",
        description: "新密码不符合规则，请修改",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return
      // 两遍密码是否一致
    } else if(this.state.newPsd !== this.state.againPsd) {
      Message.showMsg({
        showIcon: true,
        type: "success",
        description: "两遍新密码不一致，请修改",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return
    }
    // voptest vop123456789
    try {
        const res = await updatePassword({
          oldPwd: md5(this.state.oldPsd),
          newPwd: md5(this.state.newPsd)
        });
        console.log('res', res)

        if(res.data.success == true) {
          // 密码修改成功，请重新登录。稍后打开登录界面
          Message.showMsg({
            showIcon: true,
            type: "success",
            description: "密码修改成功，请重新登录。稍后打开登录界面",
            autohide: true,
            closable: false,
            duration: 300000,
          });
          // 跳到登录页
          window.location = loginUrl;
        } else {
          // 修改失败-依据返回错误提示客户重新修改密码后操作
          // Message.showMsg({
          //   showIcon: true,
          //   type: "error",
          //   description: res.data.resultMessage,
          //   autohide: true,
          //   closable: false,
          //   duration: 300000,
          // });
        }
    } catch(e) {
      // console.log('error')
    }
  }

  // 取消
  handleCancel= () => {
    window.history.back(-1);
  }

  render() {
    let { oldPsd, newPsd, againPsd } = this.state;
    return (
      <React.Fragment>
        <div
          className="jdw-widget"
          data-name="vop_header"
          data-version="6.0.0"
        >
          <VopHeader flow contentWidth="1200px">
            <HomeHeader />
          </VopHeader>
        </div>

        <div className="editpsd-wrapper">
          <div className="editpsd-center">
            <div className="editpsd-content">
              <h3 className="editpsd-title">修改账户密码</h3>
              <div className="input_item">
                <span className="title">旧密码：</span>
                <Input
                  className="authCallbackUrl"
                  placeholder="请输入当前密码"
                  type="password"
                  maxLength={20}
                  value={ oldPsd }
                  onChange={this.inputOld}
                  hasClear
                />
              </div>
              <div className="input_item info">
                <span className="title">新密码：</span>
                <Input
                  className="authCallbackUrl"
                  placeholder="请输入新密码"
                  value={ newPsd }
                  type="password"
                  maxLength={20}
                  onChange={this.inputNew}
                  hasClear
                />
                <span className="infoMsg">密码规则：数字/字母/符号两种以上组合，8-20位</span>
              </div>
              <div className="input_item">
                <span className="title">确认新密码：</span>
                <Input
                  className="authCallbackUrl"
                  placeholder="请再次输入新密码"
                  type="password"
                  value={ againPsd }
                  maxLength={20}
                  onChange={this.inputAgain}
                  hasClear
                />
                {/* <span className="infoMsg">密码规则：数字/字母/符号两种以上组合，8-20位</span> */}
                <span className="errMsg">密码规则：数字/字母/符号两种以上组合，8-20位</span>
              </div>
              <div className="btn-box">
                <Button className="btn" onClick={this.handleCancel}>
                  取消
                </Button>
                <Button className="btn" styleType="primary"
                  onClick={() => this.handleCreate()}
                  clstag="pageclick|keycount|VopOpenIndex_1602911919488|35"
                >
                  确认修改
                </Button>
              </div>
            </div>
          </div>
          <div className="editpsd-footer">
            <VopFooter />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default EditPsd;
